import { createContext, useContext } from "react";
import { useReadTheme } from "./useReadTheme";

const ReadThemeCtx = createContext({ theme: "light", toggle: () => {} });

export function ReadThemeProvider({ children }) {
  const [theme, , toggle] = useReadTheme();
  return (
    <ReadThemeCtx.Provider value={{ theme, toggle }}>
      {children}
    </ReadThemeCtx.Provider>
  );
}

export function useReadThemeCtx() {
  return useContext(ReadThemeCtx);
}
